var _text, _text2, _text3, _text4, _text5, _text6, _line, _line2, _line3, _line4, _line5, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path5, _g8, _g9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 353,
    viewBox: "0 0 218 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 30,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Networth"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 90,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Goals & Expenses"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 150,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Post Retirement Income"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 205,
    fill: "#0B2653",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", null, "Risk Assesment"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 260,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Asset Allocation"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 315,
    fill: "#51668A"
  }, /*#__PURE__*/React.createElement("tspan", null, "Portfolio Construction"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 46,
    x2: 33,
    y2: 68,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 106,
    x2: 33,
    y2: 128,
    stroke: "#27AE60",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 164,
    x2: 33,
    y2: 186,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 221,
    x2: 33,
    y2: 245,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 277,
    x2: 33,
    y2: 301,
    stroke: "#B9C2D0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 7C43.598 7 53 16.402 53 28C53 39.598 43.598 49 32 49C20.402 49 11 39.598 11 28C11 16.402 20.402 7 32 7ZM32 46.0802C41.9854 46.0802 50.0802 37.9854 50.0802 28C50.0802 18.0146 41.9854 9.91976 32 9.91976C22.0146 9.91976 13.9198 18.0146 13.9198 28C13.9198 37.9854 22.0146 46.0802 32 46.0802Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66C43.598 66 53 75.402 53 87C53 98.598 43.598 108 32 108C20.402 108 11 98.598 11 87C11 75.402 20.402 66 32 66ZM32 105.08C41.9854 105.08 50.0802 96.9854 50.0802 87C50.0802 77.0146 41.9854 68.9198 32 68.9198C22.0146 68.9198 13.9198 77.0146 13.9198 87C13.9198 96.9854 22.0146 105.08 32 105.08Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 125C43.598 125 53 134.402 53 146C53 157.598 43.598 167 32 167C20.402 167 11 157.598 11 146C11 134.402 20.402 125 32 125ZM32 164.08C41.9854 164.08 50.0802 155.985 50.0802 146C50.0802 136.015 41.9854 127.92 32 127.92C22.0146 127.92 13.9198 136.015 13.9198 146C13.9198 155.985 22.0146 164.08 32 164.08Z",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 184C34.7578 184 37.4885 184.543 40.0364 185.599C42.5842 186.654 44.8992 188.201 46.8492 190.151C48.7993 192.101 50.3461 194.416 51.4015 196.964C52.4568 199.511 53 202.242 53 205H50.0802C50.0802 202.626 49.6126 200.275 48.704 198.081C47.7953 195.887 46.4636 193.894 44.7847 192.215C43.1058 190.536 41.1126 189.205 38.919 188.296C36.7254 187.387 34.3743 186.92 32 186.92L32 184Z",
    fill: "#0B2653"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_210_231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 16,
    fill: "#27AE60"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 31.6978L25.6258 28.3865C25.2534 28.0143 24.6517 28.0143 24.2793 28.3865C23.9069 28.7586 23.9069 29.3598 24.2793 29.732L28.271 33.7209C28.6434 34.093 29.245 34.093 29.6174 33.7209L39.7207 23.6247C40.0931 23.2525 40.0931 22.6513 39.7207 22.2791C39.3483 21.907 38.7466 21.907 38.3742 22.2791L28.9394 31.6978Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_210_231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 87,
    r: 16,
    fill: "#27AE60"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_210_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 90.6978L25.6258 87.3865C25.2534 87.0143 24.6517 87.0143 24.2793 87.3865C23.9069 87.7586 23.9069 88.3598 24.2793 88.732L28.271 92.7209C28.6434 93.093 29.245 93.093 29.6174 92.7209L39.7207 82.6247C40.0931 82.2525 40.0931 81.6513 39.7207 81.2791C39.3483 80.907 38.7466 80.907 38.3742 81.2791L28.9394 90.6978Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_210_231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 146,
    r: 16,
    fill: "#27AE60"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_210_231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9394 149.698L25.6258 146.386C25.2534 146.014 24.6517 146.014 24.2793 146.386C23.9069 146.759 23.9069 147.36 24.2793 147.732L28.271 151.721C28.6434 152.093 29.245 152.093 29.6174 151.721L39.7207 141.625C40.0931 141.252 40.0931 140.651 39.7207 140.279C39.3483 139.907 38.7466 139.907 38.3742 140.279L28.9394 149.698Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_210_231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 205,
    r: 16,
    fill: "#0B2653"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2926 199.844C36.2821 199.705 34.3459 198.873 32.9309 197.555L32.5584 197.208C32.4096 197.069 32.2234 197 32 197C31.7767 197 31.5904 197.069 31.4416 197.208L31.0692 197.555C29.6171 198.907 27.7183 199.705 25.7075 199.844C25.2979 199.878 25 200.191 25 200.572V202.653C25 207.022 27.5317 211.079 31.6276 213.229C31.7392 213.299 31.8883 213.333 32 213.333C32.1488 213.333 32.2608 213.299 32.3724 213.229C36.4683 211.079 39 207.022 39 202.653V200.572C39 200.191 38.7021 199.879 38.2925 199.844H38.2926ZM31.9629 200.711C32.5959 200.711 33.1171 201.196 33.08 201.82L32.8566 205.878C32.8195 206.329 32.4471 206.675 31.963 206.675C31.4789 206.675 31.1067 206.328 31.0693 205.878L30.8459 201.82C30.8459 201.196 31.33 200.711 31.963 200.711H31.9629ZM31.9629 209.657C31.2929 209.657 30.7713 209.172 30.7713 208.548C30.7713 207.923 31.2926 207.438 31.9629 207.438C32.633 207.438 33.1545 207.923 33.1545 208.548C33.1543 209.172 32.633 209.657 31.9629 209.657Z",
    fill: "white"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_210_231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 261,
    r: 16,
    fill: "#4081BD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.5559 258.937C38.1502 257.606 37.3455 256.466 36.2268 255.633L32.5996 260.755L38.4679 262.98C38.9316 261.664 38.9621 260.268 38.556 258.937L38.5559 258.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4826 261.112L31.4653 261.097C31.4486 261.078 31.4366 261.057 31.4295 261.034C31.4146 260.986 31.4232 260.932 31.4531 260.889L35.2042 255.592C35.0212 255.47 34.8306 255.355 34.6354 255.251C33.6929 254.75 32.6391 254.484 31.5877 254.484C30.9487 254.484 30.3109 254.58 29.6921 254.769C28.0314 255.276 26.6676 256.399 25.8516 257.931C25.0357 259.464 24.8654 261.222 25.3719 262.883C25.8786 264.544 27.0017 265.907 28.5342 266.724C29.475 267.225 30.5281 267.489 31.5804 267.489C32.2224 267.489 32.8638 267.393 33.4861 267.203C35.3611 266.631 36.8561 265.264 37.5998 263.444L31.511 261.133C31.4973 261.126 31.488 261.118 31.4824 261.113L31.4826 261.112Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_210_231)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 317,
    r: 16,
    fill: "#A85CD7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 312.162H35.8001V310.296C35.8001 309.929 35.5001 309.629 35.1335 309.629H28.6001C28.2334 309.629 27.9334 309.929 27.9334 310.296V312.162H25C24.4334 312.162 24 312.629 24 313.162V315.729H40V313.162C40 312.629 39.5666 312.162 39 312.162H39.0001ZM29.2667 310.962H34.4667V312.162H29.2667V310.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8 318.059H36.1V316.859H27.9V318.059H26.2V316.859H24V323.359C24 323.893 24.4334 324.359 25 324.359H39C39.5667 324.359 40 323.893 40 323.359V316.859H37.8V318.059Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_210_231",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_210_231",
    x: 0,
    y: 59,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_210_231",
    x: 0,
    y: 118,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_210_231",
    x: 0,
    y: 177,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_210_231",
    x: 0,
    y: 233,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_210_231",
    x: 0,
    y: 289,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_210_231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_210_231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_210_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 77)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_210_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22 136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step_4.102f3bc9316b07b52090bd4ae0848f60.svg";
export { ForwardRef as ReactComponent };